import React from 'react'
import styled from 'styled-components'
import { Borders, Colors } from '../../constants'
import { Flip } from '../icons'

interface Props {
  onClick: () => void
}

export function FlipInputCurrencies({ onClick }: Props) {
  return (
    <Content>
      <Button title="Flip token input and output" onClick={onClick}>
        <Flip />
      </Button>
    </Content>
  )
}

const Content = styled.div`
  margin: 5px 0 10px 0;
  padding: 0 20px;
  text-align: center;
`

const Button = styled.button`
  margin: 0 auto;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid ${Borders.Color};
  border-radius: ${Borders.Radius};
  background: rgb(239, 239, 239);
  background: linear-gradient(0deg, rgba(239, 239, 239, 1) 0%, rgba(238, 238, 238, 1) 100%);
  outline: 0;
  cursor: pointer;

  &:focus {
    border-color: ${Colors.Hover};
  }

  &:hover {
    color: ${Colors.Hover};
    border-color: ${Colors.Hover};
  }
`
